module.exports = "/_next/static/media/c2e77986cb31b895c1738bba28f5a1e6.svg";